import { Tab, TabGroup } from "../../../../components/design-system";
import { ADS_MANAGER_SURFACE_CLASS } from "../constants/layout";
import type { PlTab } from "../types";

import { AdsManagerContent } from "./AdsManagerContent";

const TABS: { value: PlTab; label: string; badge?: string }[] = [
  { value: "overview", label: "Overview" },
  { value: "customers", label: "Customers" },
  { value: "products", label: "Products" },
];

type PromotedListingsTabsProps = {
  activeTab: PlTab;
  onTabChange: (tab: PlTab) => void;
};

export function PromotedListingsTabs({
  activeTab,
  onTabChange,
}: PromotedListingsTabsProps) {
  return (
    <div className={`border-b border-[#dfe0e1] ${ADS_MANAGER_SURFACE_CLASS}`}>
      <AdsManagerContent className="pt-2">
        <TabGroup
          selectedTabValue={activeTab}
          onSelect={(value) => onTabChange(value as PlTab)}
          hideBorder
        >
          {TABS.map((tab) => (
            <Tab
              key={tab.value}
              value={tab.value}
              label={tab.label}
              badge={tab.badge}
            />
          ))}
        </TabGroup>
      </AdsManagerContent>
    </div>
  );
}
